import { Button } from 'antd';

const renderSearchError = (onRetry: () => void) => (
  <Button onClick={onRetry}>Tentar carregar a busca novamente</Button>
);

export default renderSearchError;
